// @flow

import React, { PureComponent } from "react";
import moment from "moment";

import { Text } from "@unifize/sarah";
import * as colors from "src/styles/constants/colors";

type Props = {
  timestamp: string,
};

// Using PureComponent to avoid re-rendering
class Timestamp extends PureComponent<Props> {
  render() {
    const { timestamp } = this.props;
    return (
      <Text variant="pill" color={colors.grey21Alpha}>
        {moment(timestamp).format("hh:mm a")}
      </Text>
    );
  }
}

export default Timestamp;
